module.exports = __webpack_public_path__ + "img/ring_y_l_1_1.c12d559d.png";